import { ConcreteEncodable } from "./ConcreteEncodable";

import { TimeZoneImplEncoder } from "../../encoder/TimeZoneImplEncoder";

import * as CubiqTS from "../../index";
import { TimeZone } from "../TimeZone";

export class TimeZoneImpl extends ConcreteEncodable implements TimeZone {
  public static enType: string = "com.bcdfx.model.calendar.TimeZoneImpl";

  /*FID=1*/
  public id: string;
  /*FID=2*/
  public javaTimeZoneCd: string;
  /*FID=3*/
  public tzRegionName: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = TimeZoneImplEncoder.Instance;
    this.setEncodableType(TimeZoneImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TimeZoneImpl[" +
      "id=" +
      this.id +
      "javaTimeZoneCd=" +
      this.javaTimeZoneCd +
      "tzRegionName=" +
      this.tzRegionName +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
